import _createClass from "/Users/songzhou/Desktop/contact-form/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/Users/songzhou/Desktop/contact-form/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _defineProperty from "/Users/songzhou/Desktop/contact-form/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classPrivateFieldInitSpec from "/Users/songzhou/Desktop/contact-form/node_modules/@babel/runtime/helpers/esm/classPrivateFieldInitSpec.js";
import _classPrivateFieldGet from "/Users/songzhou/Desktop/contact-form/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet.js";
import _classPrivateFieldSet from "/Users/songzhou/Desktop/contact-form/node_modules/@babel/runtime/helpers/esm/classPrivateFieldSet.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.weak-map.js";
import "core-js/modules/web.dom-collections.iterator.js";
// Copyright 2019-2022 @polkadot/wasm-bridge authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { getRandomValues } from '@polkadot/x-randomvalues';
var DEFAULT_CRYPTO = {
  getRandomValues: getRandomValues
};
var DEFAULT_SELF = {
  crypto: DEFAULT_CRYPTO
};

var _bridge = /*#__PURE__*/new WeakMap();

export var Wbg = /*#__PURE__*/_createClass(function Wbg(bridge) {
  var _this = this;

  _classCallCheck(this, Wbg);

  _classPrivateFieldInitSpec(this, _bridge, {
    writable: true,
    value: void 0
  });

  _defineProperty(this, "abort", function () {
    throw new Error('abort');
  });

  _defineProperty(this, "__wbindgen_is_undefined", function (idx) {
    return _classPrivateFieldGet(_this, _bridge).getObject(idx) === undefined;
  });

  _defineProperty(this, "__wbindgen_throw", function (ptr, len) {
    throw new Error(_classPrivateFieldGet(_this, _bridge).getString(ptr, len));
  });

  _defineProperty(this, "__wbg_self_1b7a39e3a92c949c", function () {
    return _classPrivateFieldGet(_this, _bridge).addObject(DEFAULT_SELF);
  });

  _defineProperty(this, "__wbg_require_604837428532a733", function (ptr, len) {
    throw new Error("Unable to require ".concat(_classPrivateFieldGet(_this, _bridge).getString(ptr, len)));
  });

  _defineProperty(this, "__wbg_crypto_968f1772287e2df0", function (_idx) {
    return _classPrivateFieldGet(_this, _bridge).addObject(DEFAULT_CRYPTO);
  });

  _defineProperty(this, "__wbg_getRandomValues_a3d34b4fee3c2869", function (_idx) {
    return _classPrivateFieldGet(_this, _bridge).addObject(DEFAULT_CRYPTO.getRandomValues);
  });

  _defineProperty(this, "__wbg_getRandomValues_f5e14ab7ac8e995d", function (_arg0, ptr, len) {
    DEFAULT_CRYPTO.getRandomValues(_classPrivateFieldGet(_this, _bridge).getU8a(ptr, len));
  });

  _defineProperty(this, "__wbg_randomFillSync_d5bd2d655fdf256a", function (_idx, _ptr, _len) {
    throw new Error('randomFillsync is not available'); // getObject(idx).randomFillSync(getU8a(ptr, len));
  });

  _defineProperty(this, "__wbindgen_object_drop_ref", function (idx) {
    _classPrivateFieldGet(_this, _bridge).takeObject(idx);
  });

  _classPrivateFieldSet(this, _bridge, bridge);
});
export function initWbg(bridge) {
  return new Wbg(bridge);
}